module.exports = __webpack_public_path__ + "img/tower2_true.bd35a0f0.png";